(() => {
  const key = 'mindvey-wishlist-v1';
  let items = [];
  const clean = value => Array.isArray(value) ? value.filter(x => x && typeof x.id === 'string' && typeof x.title === 'string' && typeof x.url === 'string' && x.url.startsWith('/') && !x.url.startsWith('//')).slice(0,100) : [];
  try { items = clean(JSON.parse(localStorage.getItem(key) || '[]')); } catch (_) {}
  function update() {
    document.querySelectorAll('[data-mv-wishlist-count]').forEach(el => el.textContent = items.length);
    document.querySelectorAll('[data-mv-product]').forEach(el => {
      const button = el.querySelector('[data-mv-save]');
      if (!button) return;
      const saved = items.some(x => x.id === el.dataset.id);
      button.setAttribute('aria-pressed', String(saved));
      button.textContent = saved ? '♥ ' + (el.dataset.savedLabel || 'Saved to wishlist') : '♡ ' + (el.dataset.saveLabel || 'Wishlist');
    });
  }
  function persist(status) {
    try { localStorage.setItem(key, JSON.stringify(items)); }
    catch (_) { if (status) status.textContent = 'Browser storage is unavailable. Saved for this visit only.'; }
    update();
  }
  function render() {
    const target = document.querySelector('[data-mv-wishlist-items]');
    target.replaceChildren();
    if (!items.length) { const p = document.createElement('p'); p.textContent = 'Your wishlist is empty. Save products you love to find them here.'; target.append(p); }
    items.forEach(item => {
      const row = document.createElement('div'); row.className = 'mv-wishlist-item';
      if (item.image) {
        try { const u = new URL(item.image, location.origin); if (u.protocol === 'https:') { const img = document.createElement('img'); img.src = u.href; img.alt = item.title; img.loading = 'lazy'; row.append(img); } } catch (_) {}
      }
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
      remove.addEventListener('click', () => { const index = items.findIndex(x => x.id === item.id); items = items.filter(x => x.id !== item.id); persist(); render(); const buttons = target.querySelectorAll('button'); (buttons[Math.min(index, buttons.length - 1)] || document.querySelector('[data-mv-wishlist-close]')).focus(); });
      row.append(link, remove); target.append(row);
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('button'); if (!button) return;
    const card = button.closest('[data-mv-product]');
    if (button.hasAttribute('data-mv-save') && card) {
      const status = card.querySelector('[data-mv-status]'); status.textContent = '';
      if (items.some(x => x.id === card.dataset.id)) { items = items.filter(x => x.id !== card.dataset.id); status.textContent = 'Removed from wishlist.'; }
      else { if (items.length >= 100) { status.textContent = 'Your wishlist is full. Remove an item first.'; return; } items.push({id:card.dataset.id,title:card.dataset.title,url:card.dataset.url,image:card.dataset.image}); status.textContent = 'Added to wishlist.'; }
      persist(status);
    }
    if (button.hasAttribute('data-mv-share') && card) {
      const status = card.querySelector('[data-mv-status]'); const url = new URL(card.dataset.url, location.origin); url.search = location.search;
      try {
        if (navigator.share) { await navigator.share({title:card.dataset.title,url:url.href}); status.textContent = 'Shared.'; }
        else if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(url.href); status.textContent = 'Product link copied.'; }
        else { window.prompt('Copy this product link:', url.href); }
      } catch (error) { if (error.name !== 'AbortError') { window.prompt('Copy this product link:', url.href); } }
    }
    if (button.hasAttribute('data-mv-wishlist-open')) { render(); document.getElementById('mv-wishlist-dialog').showModal(); }
    if (button.hasAttribute('data-mv-wishlist-close')) document.getElementById('mv-wishlist-dialog').close();
  });
  window.addEventListener('storage', event => { if (event.key === key) { try { items = clean(JSON.parse(event.newValue || '[]')); update(); if (document.getElementById('mv-wishlist-dialog').open) render(); } catch (_) {} } });
  document.addEventListener('shopify:section:load', update);
  update();
})();
